document.addEventListener("DOMContentLoaded", function () {

  // ===================================================
  // Coffee Demo Form
  // ===================================================

  const coffeeForm = document.getElementById("coffeeDemoForm");

  if (coffeeForm) {

    coffeeForm.addEventListener("submit", function (e) {

      const phoneInput = coffeeForm.querySelector('[name="contact[Phone]"]');

      phoneInput.setCustomValidity("");

      if (!phoneInput.value.trim()) {
        e.preventDefault();
        phoneInput.setCustomValidity("Please enter your phone number.");
        phoneInput.reportValidity();
        return;
      }

      const phone = phoneInput.value.trim();
      const phoneRegex = /^[6-9]\d{9}$/;

      if (!phoneRegex.test(phone)) {
        e.preventDefault();
        phoneInput.setCustomValidity("Please enter a valid 10-digit mobile number.");
        phoneInput.reportValidity();
        return;
      }

      const payload = {
        formType: "contact",
        name: coffeeForm.querySelector('[name="contact[name]"]')?.value || "",
        phone: phone,
        email: coffeeForm.querySelector('[name="contact[email]"]')?.value || "",
        company: coffeeForm.querySelector('[name="contact[Company]"]')?.value || "",
        teamSize: coffeeForm.querySelector('[name="contact[Team Size]"]')?.value || "",
        industry: coffeeForm.querySelector('[name="contact[Industry]"]')?.value || "",
        city: coffeeForm.querySelector('[name="contact[City]"]')?.value || ""
      };

      const endpoint = window.googleScriptEndpoint ||
        "https://script.google.com/macros/s/AKfycbxBZN17xwEmDazmIn1s7UaLb7lgBC4DxeXqiYHrUnysSCVhNlZ2a_EIwWXooc0dMkf2tg/exec";

      fetch(endpoint, {
        method: "POST",
        mode: "no-cors",
        headers: {
          "Content-Type": "text/plain"
        },
        body: JSON.stringify(payload)
      }).catch(function (err) {
        console.error("Google Sheet Error:", err);
      });

      sessionStorage.setItem("submittedForm", "contact");

    });

  }


  // ===================================================
  // Thank You / Download
  // ===================================================

  const params = new URLSearchParams(window.location.search);

  if (params.has("contact_posted")) {

    const type = sessionStorage.getItem("submittedForm");

    if (type === "contact") {

      sessionStorage.removeItem("submittedForm");

      window.location.href = "/pages/thankyou";

    }


  }

});
